import { render, staticRenderFns } from "./FilterChangelog.vue?vue&type=template&id=d4f2f9a8&"
import script from "./FilterChangelog.vue?vue&type=script&lang=js&"
export * from "./FilterChangelog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports